module.exports = __webpack_public_path__ + "img/36.b4919c65.webp";